import PrintModal from './PrintModal';

export default PrintModal;